import { useState, useEffect } from "react";

export default function useWindowSize() {
    
  function getSize() {
    return {
      width: typeof window !== "undefined" && window.innerWidth,
      height: typeof window !== "undefined" && window.innerHeight
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    let locomotiveScroll = typeof window !== "undefined" && window.scroll;
  
    function handleResize() {
      typeof window !== "undefined" && locomotiveScroll.update();
      setWindowSize(getSize());
    }

    typeof window !== "undefined" && window.addEventListener("resize", handleResize);
    return () => typeof window !== "undefined" && window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}